var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 0 26)",
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 18.8262,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 0 18.8262)",
    fill: "#666666"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 11.6553,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 0 11.6553)",
    fill: "#666666"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 4.48242,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 0 4.48242)",
    fill: "#666666"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.62012,
    y: 26,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 7.62012 26)",
    fill: "#666666"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.62012,
    y: 18.8262,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 7.62012 18.8262)",
    fill: "#666666"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.62012,
    y: 11.6553,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 7.62012 11.6553)",
    fill: "#666666"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.62012,
    y: 4.48242,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 7.62012 4.48242)",
    fill: "#666666"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2388,
    y: 26,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 15.2388 26)",
    fill: "#666666"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2383,
    y: 18.8262,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 15.2383 18.8262)",
    fill: "#666666"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2383,
    y: 11.6553,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 15.2383 11.6553)",
    fill: "#666666"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2383,
    y: 4.48242,
    width: 4.48281,
    height: 4.76188,
    rx: 1,
    transform: "rotate(-90 15.2383 4.48242)",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragActive);
export default __webpack_public_path__ + "static/media/drag-active.aa1118eeea70fcc842edeb16bc013787.svg";
export { ForwardRef as ReactComponent };